/** Support email for user assistance */
export const SUPPORT_EMAIL = "support@wrap.gifts";
